import { useMemo } from "react";
import { HomeSectionContent } from "@/src/api/fetchHomeSections/types";

export function useFindSection(
  data: HomeSectionContent[],
  layout: string
): HomeSectionContent | undefined {
  return useMemo(() => {
    return data.find((item) => item.acf_fc_layout === layout);
  }, [data, layout]);
}
